import { BrandPageBackground } from '@seddi/ui-kit';
import React, { type FC, type ReactNode } from 'react';
import { useAppAuth } from './appAuth.hooks';
import backgroundImage from './background_image.png';
import { AppAccountLoad } from './appAccountLoad';
import { AppLogin } from './appLogin';

type AppAuthProps = {
  children: ReactNode;
};

export const AppAuth: FC<AppAuthProps> = ({ children }) => {
  const { useAppAccount, user } = useAppAuth();
  if (user) {
    return children;
  }

  return (
    <BrandPageBackground image={backgroundImage}>
      {useAppAccount ? <AppAccountLoad /> : <AppLogin />}
    </BrandPageBackground>
  );
};
